import { render } from "./ParentsRecordContainer.vue?vue&type=template&id=31275114&scoped=true&ts=true"
import script from "./ParentsRecordContainer.vue?vue&type=script&lang=ts"
export * from "./ParentsRecordContainer.vue?vue&type=script&lang=ts"

import "./ParentsRecordContainer.vue?vue&type=style&index=0&id=31275114&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31275114"]])

export default __exports__